<!-- Missing/mangled link params -->
<div *ngIf="linkInvalid" class="row justify-content-center mt-5">
  <div class="col-12 col-md-8 col-lg-5 text-center">
    <span class="fa-solid fa-link-slash invalid-icon"></span>
    <h2 class="noselect mt-3">This link isn't valid</h2>
    <p class="text-muted noselect">
      The reset link is incomplete or has already been used. Request a new one below.
    </p>
    <a class="btn btn-primary mt-2" [routerLink]="['/authentication', 'forgot-password']">Request a New Link</a>
  </div>
</div>

<div *ngIf="!linkInvalid" class="row justify-content-center mt-5">
  <div class="col-12 col-md-8 col-lg-4 text-center">
    <h2 class="noselect">Choose a new password</h2>
    <p class="text-muted noselect">Resetting the password for {{ email }}</p>
  </div>
  <div class="d-100"></div>
  <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="row justify-content-center w-100">
    <div class="col-12 col-md-6 col-lg-4">
      <app-input [form]="resetForm" formGroupName="password" placeHolder="New Password" inputType="password" [passwordHelpEnabled]="true"></app-input>
    </div>
    <div class="d-100"></div>
    <div class="col-12 col-md-6 col-lg-4">
      <app-input [form]="resetForm" formGroupName="confirmPassword" placeHolder="Confirm New Password" inputType="password"></app-input>
    </div>
    <div class="d-100"></div>
    <div class="col-12 col-md-6 col-lg-4 mt-2">
      <button class="btn btn-primary w-100" type="submit" [disabled]="isSubmitting">
        <span *ngIf="!isSubmitting">Reset Password</span>
        <span *ngIf="isSubmitting"><span class="spinner-border spinner-border-sm me-1"></span>Resetting…</span>
      </button>
    </div>
    <div class="d-100"></div>
    <div class="col-auto mt-3">
      <a [routerLink]="['/authentication', 'login']">Back to login</a>
    </div>
  </form>
</div>
